import {
  IS_IE_BROWSER,
} from '../../common/config';

class AudioViewerController {
  constructor(
    $scope,
    $timeout,
    AudioViewerService,
  ) {
    this.$scope = $scope;
    this.AudioViewerService = AudioViewerService;

    function getFileSize(url) {
      return new Promise((resolve, reject) => {
        const http = new XMLHttpRequest();
        http.open('HEAD', url, true); // true = Asynchronous
        http.onreadystatechange = function() {
          const setErr = errText => {
            const err = {
              status: this.status,
              text: errText
            };
            console.error(err);
          };

          if (this.status === 200) {
            const contentLength = this.getResponseHeader('content-length');
            const fileSizeMb = Number(contentLength) / 1024 / 1024;
            if (isNaN(fileSizeMb)) reject(setErr(`wrong content-length: ${contentLength}`));
            else resolve(fileSizeMb);
          } else {
            reject(setErr(`wrong url: "${url}"`));
          }
        };
        http.send();
      });
    }

    if (!IS_IE_BROWSER) {
      $timeout(() => {
        if (this.src && this.fact && this.fact.fileSize == undefined) {
          getFileSize(this.src)
            .then(size => {
              this.fact.fileSize = size;
            });
        }
      }, 100);
    }
  }

  get isWaves() {
    if (this.fact.fileSize == undefined) return '0';
    return this.AudioViewerService.isWaves(this.fact)? '1': '2';
  }
}

export const AudioViewerComponent = {
  template: require('./audio-viewer.component.html'),
  controller: AudioViewerController,
  bindings: {
    fact: '<',
    src: '<',
  },
};



// WEBPACK FOOTER //
// ./src/facts/audio-waves/audio-viewer.component.js